import { CardAction, ChickletHoverActions, ChickletPrimaryDisplayLabel } from '../../constants/BehaviorTypes';
import { ChickletSecondaryDisplayLabels } from '../../constants/BehaviorTypes';
import AlertChickletPrimaryDisplayLabel from '../../behaviors/flywheel/alert/AlertChickletPrimaryDisplayLabel';
import FlywheelAlertCardAction from '../../behaviors/flywheel/alert/FlywheelAlertCardAction';
import useGetAlertChickletSecondaryDisplayLabels from '../../behaviors/flywheel/alert/getAlertChickletSecondaryDisplayLabels';
import getFlywheelAlertChickletHoverAction from '../../behaviors/flywheel/alert/getFlywheelAlertChickletHoverAction';
export const Alert = {
  [ChickletPrimaryDisplayLabel]: () => AlertChickletPrimaryDisplayLabel,
  [ChickletHoverActions]: () => getFlywheelAlertChickletHoverAction,
  [ChickletSecondaryDisplayLabels]: () => useGetAlertChickletSecondaryDisplayLabels,
  [CardAction]: () => FlywheelAlertCardAction
};